import { flatten, replace } from "lodash";
const prepareElementWithPageBreak = (string) => {
  if (string.indexOf("<!-- pagebreak -->") > -1) {
    const data = replace(
      string,
      "<!-- pagebreak -->",
      "<!-- pagebreak-split-by --><!-- pagebreak --><!-- pagebreak-split-by -->"
    );
    return data.split("<!-- pagebreak-split-by -->");
  } else {
    return string;
  }
};

const isLastElement = (index, arr) => index === arr.length - 1;

const groupArticleSplitByPages = (body) => {
  let article = [];
  let temporaryArticlePart = [];
  body.forEach((el, i) => {
    if (el === "<!-- pagebreak -->") {
      article = [...article, temporaryArticlePart];
      temporaryArticlePart = [];
    } else {
      temporaryArticlePart = [...temporaryArticlePart, el];
      if (isLastElement(i, body)) {
        article = [...article, temporaryArticlePart];
      }
    }
  });
  return article;
};

const createFlattenArrayWithPageBreak = (array) =>
  flatten(array.map((el) => prepareElementWithPageBreak(el)));

export const getArticleDataByPages = (article) => {
  const array = createFlattenArrayWithPageBreak(article);
  const articleByPages = groupArticleSplitByPages(array);
  return articleByPages;
};
